export const getAdjustmentsState = (state) => state.adjustments;

export const getAdjustmentState = (state) => state.adjustment;

export const getAdjustmentLogState = (state) => state.adjustmentLog;
